import { EnumTypeDocumentWdh } from 'utils/__enums/MyDocuments/TypesDocument'

const UNFOUND_DOCUMENT_TYPES: Partial<Record<EnumTypeDocumentWdh, string>> = {
  [EnumTypeDocumentWdh.FACTURE]: 'Copie de facture',
  [EnumTypeDocumentWdh.AVOIR]: 'Copie de facture',
  [EnumTypeDocumentWdh.BI]: 'Bon intervention',
  [EnumTypeDocumentWdh.BP]: 'Bon pesée',
  [EnumTypeDocumentWdh.BRM]: 'Bordereau Rachat Matière (BRM)',
  [EnumTypeDocumentWdh.ATTESTATION_VALO]: 'Attestation 6 flux',
  [EnumTypeDocumentWdh.FICHE_DECLASSEMENT]: 'Autre',
}

export default UNFOUND_DOCUMENT_TYPES
